import React, { useState } from 'react';
import Modal from './Modal';
import Button from './Button';
import { useT } from '../../i18n/LocaleContext';

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  body,
  confirmLabel,
  cancelLabel,
  variant = 'danger',
}) {
  const t = useT();
  const [busy, setBusy] = useState(false);

  const handleConfirm = async () => {
    try {
      setBusy(true);
      await onConfirm?.();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={busy ? () => {} : onClose}
      size="sm"
      title={title}
      footer={(
        <>
          <Button variant="ghost" onClick={onClose} disabled={busy}>
            {cancelLabel || t('common.cancel')}
          </Button>
          <Button
            variant={variant === 'danger' ? 'danger' : 'primary'}
            onClick={handleConfirm}
            loading={busy}
          >
            {confirmLabel || t('common.confirm')}
          </Button>
        </>
      )}
    >
      <p className="modal-body-text">{body}</p>
    </Modal>
  );
}
